<template>
  <ul class="list-group mt-2">
    <li
      class="list-group-item text-muted threepadding"
      v-for="s in stats"
      :key="s"
    >
      <div class="row">
        <div class="col">
          {{ s }}
        </div>
      </div>
    </li>
  </ul>
</template>
<script setup>
import { defineProps, ref, onMounted } from "vue";
const props = defineProps(["player_id"]);
import supabase from "@/supabase/config";

const stats = ref([]);
const player_id = ref("");

onMounted(() => {
  player_id.value = props.player_id;
  setTimeout(() => {
    fetchStats();
  }, 1000);
});
const fetchStats = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("id", player_id.value);
  stats.value = players[0].stats;
};
</script>
<style scoped>
.tinylist {
  padding: 0px;
  font-size: 8px;
}
.threepadding {
  padding: 3px;
}
.tinytxt {
  font-size: 8px;
  padding: 3px;
}
</style>
